<script>
import ServidorDadosPessoais from '@/components/shared/servidor/ServidorDadosPessoais.vue'

export default {
  extends: ServidorDadosPessoais,
}
</script>
